module.exports = __webpack_public_path__ + "img/ExtraAdditionalServices-banner-jp.1a2d7c3.png";